var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("left-menu-members-list-preview", {
    attrs: {
      "endpoint-key": _vm.membersEndpointKey,
      endpoint: _vm.membersEndpoint,
      "members-link": _vm.membersLink,
      title: _vm.membersTitle,
      "use-simple-link": "",
      "see-all-text": "See all members",
      "see-all-link-highlighted": _vm.$route.name === "groupDetailPage-members",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }